import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const Intro = () => {
    return (
        <section id="about" className="bg-gray-700 border-y-8 py-8 border-primary">
            <div className="container mx-auto px-4">
                <div className="flex flex-col lg:flex-row items-center">
                    <div className="lg:w-1/2 mb-8 lg:mb-0" data-aos="fade-right">
                    <div className="transition-all ease-in-out duration-400 overflow-hidden p-3">
                                <DotLottieReact
      src="https://lottie.host/db235c97-ce7a-48bb-a88f-1160a68ef365/tfPXRfFgK4.lottie"
      loop
      autoplay
    />
    </div>
                    </div>
                    <div className="lg:w-1/2 lg:pl-8" data-aos="fade-left">
                        <h2 className="text-3xl font-bold mb-4 text-primary">About Technodevotion</h2>
                        <p className="text-xl text-secondary mb-4">We are a team of passionate technologists dedicated to delivering cutting-edge solutions.</p>
                        <p className="text-secondary mb-6">At Technodevotion, we combine technical expertise with creative innovation to build software that makes a difference. Our team of experienced developers, designers, and project managers work together to create solutions that drive business success.</p>
                        <div className="grid grid-cols-2 gap-4 mt-6">
                            <div className="flex items-center mb-3">
                                <CheckCircleIcon className="h-5 w-5 text-primary mr-2" />
                                <span className='text-secondary'>Expert Team</span>
                            </div>
                            <div className="flex items-center mb-3">
                                <CheckCircleIcon className="h-5 w-5 text-primary mr-2" />
                                <span className='text-secondary'>Quality Code</span>
                            </div>
                            <div className="flex items-center mb-3">
                                <CheckCircleIcon className="h-5 w-5 text-primary mr-2" />
                                <span className='text-secondary'>24/7 Support</span>
                            </div>
                            <div className="flex items-center mb-3">
                                <CheckCircleIcon className="h-5 w-5 text-primary mr-2" />
                                <span className='text-secondary'>Modern Tech</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Intro;